/* Import Vue */
import Vue from "vue";
/* Import UI Design of Vuetify (MIT License) */
import Vuetify from "vuetify/lib/framework";
/* Import Icon Meterial Design of Vuerify (MIT License) */
import "material-design-icons-iconfont/dist/material-design-icons.css";

/* Set UI Design of Vuetify to Vue */
Vue.use(Vuetify);

/* Export Defaluter Vuetify */
export default new Vuetify({
  /* Add Icons */
  icons: {
    iconfont: "md",
  },
});
